<div class="product-gallery__featured"
    redZoomClass="product-red-zoom product-red-zoom--layout--{{ productLayout }}"
    [redZoom]="currentItem?.image || ''"
    [redZoomThumb]="currentItem?.image || ''"
    [redZoomLazy]="true">

    <div class="product-gallery__featured-inset">
        <button *ngIf="productLayout !== 'quickview'" class="product-gallery__zoom" (click)="openPhotoSwipe(currentItem)">
            <app-icon name="zoom-in-24" size="24"></app-icon>
        </button>

        <owl-carousel-o [options]="carouselOptions" (changed)="featuredCarouselTranslated($event)" appOwlPreventClick #featuredCarousel>
            <ng-template *ngFor="let item of items" carouselSlide [id]="item.id">
                <div class="product-image product-image--location--gallery">
                    <a appClick class="product-image__body" target="_blank" [href]="item?.image" (click)="onFeaturedImageClick($event, item);">
                        <img class="product-image__img" [src]="item?.image || 'images/default_product.png'" alt="" #imageElement>
                    </a>
                </div>
            </ng-template>
        </owl-carousel-o>
    </div>
</div>

<div class="product-gallery__carousel">
    <owl-carousel-o appOwlPreventClick [options]="thumbnailsCarouselOptions" [appFakeSlides]="items?.length" #fakeSlides="appFakeSlides" #thumbnailsCarousel>
        <ng-template *ngFor="let item of items" carouselSlide [id]="item.id">
            <div appClick class="product-image product-gallery__carousel-item" [class.product-gallery__carousel-item--active]="item === currentItem" (click)="onThumbnailImageClick(item)">
                <div class="product-image__body">
                    <img class="product-image__img product-gallery__carousel-image" [src]="item?.image" alt="">
                </div>
            </div>
        </ng-template>
        
        <ng-template *ngFor="let i of fakeSlides?.slides" carouselSlide [id]="'fake-slide-'+i"></ng-template>
    </owl-carousel-o>
</div>
